import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import "./UserManagement.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import ManageUser from "../Layout/UserManagement/ManageUser";
import UserRegistration from "../Layout/UserManagement/UserRegistration";
import Login from "../auth/Login";
import Footer from "../reusables/Footer";
import { getToken } from "../auth/authConfig";
import Error403 from "../reusables/Error403";
import Error500 from "../reusables/Error500";
import LoadingScreen from "../reusables/LoadingScreen";
import Error401 from "../reusables/Error401";
import Error404 from "../reusables/Error404";
import CBUserReg from "../Layout/UserManagement/CBUserReg";
import CBManageUser from "../Layout/UserManagement/CBManageUser";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserManagement() {
  const [Tabvalue, setTabValue] = useState(0);
  const [loadingUser, setloadingUser] = useState(false);
  const [userinfo, setuserinfo] = useState({});
  const [pageDetails, setPageDetails] = useState();
  const [error, seterror] = useState(false);
  const [errorCode, seterrorCode] = useState();
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const tabHeader = [
    {
      TabHeader: "User Management",
    },
    {
      TabHeader: "User Registration",
    },
  ];

  const getUserinfo = async () => {
    setloadingUser(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getUserInfoV2`;
    const token = await getToken();

    await fetch(`${url}`, {
      headers: {
        "oidc-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setloadingUser(false);
            setuserinfo(json?.user);
            
            const info = json?.user;
            const role = info?.group_name;
            const company = info?.company;
            setPageDetails(role);
            localStorage.setItem("GroupName", role);
            localStorage.setItem("company", company);

          });
        } else if (response.status === 401) {
          setloadingUser(false);
          seterror(true);
          console.log(typeof response.status);
          seterrorCode(response.status);
        } else if (response.status === 403) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(response.status);
        } else if (response.status === 500) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(response.status);
        }
        else if (response.status === 404) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(404);
        }
      })
      .catch((err) => {
        setloadingUser(false);
      });
  };

  useEffect(() => {
    getUserinfo();
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <div id="userManagement" style={{ position: "relative" }}>
          <Box className="mainLayout" sx={{ display: "flex" }}>
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" style={{ overflowY: "auto",height:"auto" }}>
                <div
                  style={{ gridTemplateColumns: "100%", height: "100%" }}
                  id="mainChatContent"
                >
              

                  {loadingUser && (
                    <div style={{height:"100vh"}}>
                      <LoadingScreen />
                    </div>
                  )}

                  {!loadingUser && !error && (
                    <>
                      {pageDetails === "Super Admin" ? (
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                              id="TabsItems"
                              value={Tabvalue}
                              onChange={handleTabChange}
                              aria-label="basic tabs example"
                            >
                              {tabHeader.map((tabs, index) => (
                                <Tab
                                  key={index}
                                  label={tabs.TabHeader}
                                  {...a11yProps(index)}
                                />
                              ))}
                            </Tabs>
                          </Box>

                          <CustomTabPanel
                            className="TabPannel"
                            value={Tabvalue}
                            index={0}
                          >
                            <ManageUser userinfo = {userinfo}/>
                          </CustomTabPanel>

                          <CustomTabPanel
                            className="TabPannel2"
                            value={Tabvalue}
                            index={1}
                          >
                            <UserRegistration />
                          </CustomTabPanel>
                        </Box>
                      ) : (pageDetails === "CB Admin" || pageDetails === "CB Admin (Tech Reviewer)") ? (
                          <>
                          
                          <Box sx={{ width: "100%" }}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                              id="TabsItems"
                              value={Tabvalue}
                              onChange={handleTabChange}
                              aria-label="basic tabs example"
                            >
                              {tabHeader.map((tabs, index) => (
                                <Tab
                                  key={index}
                                  label={tabs.TabHeader}
                                  {...a11yProps(index)}
                                />
                              ))}
                            </Tabs>
                          </Box>

                          <CustomTabPanel
                            className="TabPannel"
                            value={Tabvalue}
                            index={0}
                          >
                            <CBManageUser userinfo = {userinfo} />
                          </CustomTabPanel>

                          <CustomTabPanel
                            className="TabPannel2"
                            value={Tabvalue}
                            index={1}
                          >
                            <CBUserReg />
                          </CustomTabPanel>
                        </Box>
                          </>
                      ) :(
                        <>
                          <Error403 />
                        </>
                      )}
                    </>
                  )}

                  {!loadingUser && error && (
                    <div>
                      {errorCode === 401 ? (
                        <>
                          <Error401 />
                        </>
                      ) : errorCode === 403 ? (
                        <>
                          <Error403 />
                        </>
                      ) : errorCode === 404 ? (
                        <>
                          <Error404 />
                        </>
                      ): (
                        <Error500 />
                      )}
                    </div>
                  )}
                </div>

                <Footer />
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
